/**
 * Brandner Search Filter - Client-seitige Instant-Filterung
 *
 * Alle Produkte sind im DOM. Filterung per show/hide (0ms statt 1-2s AJAX).
 * Client-seitige Pagination, Chips, Counts, URL-State (pushState).
 *
 * Globale Variablen (von PHP via <script>):
 * - productFilterMap: { pid: { p: [project_slugs], s: [standort_values], k: [category_slugs] } }
 * - searchFilterData: { projects: {...}, standorte: {...}, kategorien: {...} }
 */
(function($) {
    'use strict';

    var sidebar = document.getElementById('brandner-search-sidebar');
    if (!sidebar) return;
    if (typeof productFilterMap === 'undefined' || typeof searchFilterData === 'undefined') return;

    var $sidebar = $(sidebar);
    var $main = $('.brandner-search-main');
    var $layout = $('.brandner-search-layout');
    var mainEl = $main[0];
    var perPage = (typeof brandnerSearchFilter !== 'undefined' && brandnerSearchFilter.perPage) ? brandnerSearchFilter.perPage : 12;

    // Alle Produkt-Elemente im DOM
    var allProducts = Array.from(document.querySelectorAll('.brandner-search-main li.product'));
    var matchingProducts = [];
    var currentPage = 1;
    var isPopstate = false;

    // =========================================================================
    // Kern: Client-seitige Filterung
    // =========================================================================

    function applyFilter(page) {
        var selProjects = getChecked('filter_project[]');
        var selStandorte = getChecked('filter_standort[]');
        var selKategorien = getChecked('filter_kategorie[]');

        matchingProducts = [];

        allProducts.forEach(function(li) {
            var match = li.className.match(/post-(\d+)/);
            var pid = match ? match[1] : null;
            var data = pid ? productFilterMap[pid] : null;

            if (!data) {
                li.classList.add('brandner-filtered-out');
                return;
            }

            var pMatch = !selProjects.length || selProjects.some(function(s) { return data.p.indexOf(s) !== -1; });
            var sMatch = !selStandorte.length || selStandorte.some(function(s) { return data.s.indexOf(s) !== -1; });
            var kMatch = !selKategorien.length || selKategorien.some(function(s) { return data.k.indexOf(s) !== -1; });

            if (pMatch && sMatch && kMatch) {
                matchingProducts.push(li);
            }
        });

        showPage(page || 1);
        updateChips();
        updateCounts();
        if (!isPopstate) updateUrl();
        updateResetButton();
        updateMobileBadge();
        updateNoResults();
        reInitRealtime();
    }

    // =========================================================================
    // Client-Pagination
    // =========================================================================

    function showPage(page) {
        currentPage = page;

        // Alle Produkte verstecken
        allProducts.forEach(function(li) { li.classList.add('brandner-filtered-out'); });

        // Passende Produkte fuer aktuelle Seite anzeigen
        var start = (page - 1) * perPage;
        matchingProducts.slice(start, start + perPage).forEach(function(li) {
            li.classList.remove('brandner-filtered-out');
        });

        renderPagination(Math.ceil(matchingProducts.length / perPage));
    }

    function renderPagination(totalPages) {
        var existingNav = mainEl.querySelector('.woocommerce-pagination');
        if (existingNav) existingNav.remove();

        if (totalPages <= 1) return;

        var nav = document.createElement('nav');
        nav.className = 'woocommerce-pagination';
        var ul = document.createElement('ul');
        ul.className = 'page-numbers';

        // Seitennummern mit Ellipsis aufbauen
        var pages = buildPageNumbers(totalPages);

        pages.forEach(function(p) {
            var li = document.createElement('li');
            if (p === '...') {
                var span = document.createElement('span');
                span.className = 'page-numbers dots';
                span.textContent = '\u2026';
                li.appendChild(span);
            } else if (p === currentPage) {
                var span = document.createElement('span');
                span.className = 'page-numbers current';
                span.setAttribute('aria-current', 'page');
                span.textContent = p;
                li.appendChild(span);
            } else {
                var a = document.createElement('a');
                a.className = 'page-numbers';
                a.href = '#';
                a.dataset.page = p;
                a.textContent = p;
                li.appendChild(a);
            }
            ul.appendChild(li);
        });

        nav.appendChild(ul);

        // Nach der Produktliste einfuegen
        var productsList = mainEl.querySelector('ul.products');
        if (productsList) {
            productsList.parentNode.insertBefore(nav, productsList.nextSibling);
        }
    }

    function buildPageNumbers(totalPages) {
        var pages = [];
        var endSize = 2;
        var midSize = 1;

        for (var i = 1; i <= totalPages; i++) {
            if (i <= endSize || i > totalPages - endSize ||
                (i >= currentPage - midSize && i <= currentPage + midSize)) {
                pages.push(i);
            } else if (pages.length && pages[pages.length - 1] !== '...') {
                pages.push('...');
            }
        }

        return pages;
    }

    // =========================================================================
    // Chips (aktive Filter ueber dem Grid)
    // =========================================================================

    function updateChips() {
        var existing = mainEl.querySelector('.brandner-active-filters');
        if (existing) existing.remove();

        var selProjects = getChecked('filter_project[]');
        var selStandorte = getChecked('filter_standort[]');
        var selKategorien = getChecked('filter_kategorie[]');

        if (!selProjects.length && !selStandorte.length && !selKategorien.length) return;

        var container = document.createElement('div');
        container.className = 'brandner-active-filters';

        selProjects.forEach(function(v) {
            var label = (searchFilterData.projects[v] && searchFilterData.projects[v].label) || v;
            addChip(container, 'filter_project', v, label);
        });
        selStandorte.forEach(function(v) {
            var label = (searchFilterData.standorte[v] && searchFilterData.standorte[v].label) || v;
            addChip(container, 'filter_standort', v, label);
        });
        selKategorien.forEach(function(v) {
            var label = (searchFilterData.kategorien[v] && searchFilterData.kategorien[v].label) || v;
            addChip(container, 'filter_kategorie', v, label);
        });

        var clearLink = document.createElement('a');
        clearLink.href = '#';
        clearLink.className = 'clear-all-filters';
        clearLink.textContent = 'Alle Filter entfernen';
        container.appendChild(clearLink);

        // Vor dem Produkt-Grid einfuegen
        var grid = mainEl.querySelector('.archive-products') || mainEl.querySelector('ul.products');
        if (grid) {
            grid.parentNode.insertBefore(container, grid);
        }
    }

    function addChip(container, param, value, label) {
        var span = document.createElement('span');
        span.className = 'filter-chip';
        span.dataset.param = param;
        span.dataset.value = value;

        var text = document.createTextNode(label + ' ');
        span.appendChild(text);

        var remove = document.createElement('a');
        remove.href = '#';
        remove.className = 'remove';
        remove.title = 'Filter entfernen';
        remove.innerHTML = '&times;';
        span.appendChild(remove);

        container.appendChild(span);
    }

    // =========================================================================
    // Sidebar-Counts dynamisch aktualisieren
    // =========================================================================

    function updateCounts() {
        var projectCounts = {};
        var standortCounts = {};
        var kategorieCounts = {};

        matchingProducts.forEach(function(li) {
            var match = li.className.match(/post-(\d+)/);
            var pid = match ? match[1] : null;
            var data = pid ? productFilterMap[pid] : null;
            if (!data) return;

            data.p.forEach(function(s) { projectCounts[s] = (projectCounts[s] || 0) + 1; });
            data.s.forEach(function(s) { standortCounts[s] = (standortCounts[s] || 0) + 1; });
            data.k.forEach(function(s) { kategorieCounts[s] = (kategorieCounts[s] || 0) + 1; });
        });

        sidebar.querySelectorAll('input[type="checkbox"]').forEach(function(cb) {
            var name = cb.name;
            var val = cb.value;
            var countSpan = cb.closest('.search-filter-item');
            if (!countSpan) return;
            countSpan = countSpan.querySelector('.count');
            if (!countSpan) return;

            var count = 0;
            if (name === 'filter_project[]') count = projectCounts[val] || 0;
            else if (name === 'filter_standort[]') count = standortCounts[val] || 0;
            else if (name === 'filter_kategorie[]') count = kategorieCounts[val] || 0;

            countSpan.textContent = '(' + count + ')';
        });
    }

    // =========================================================================
    // URL-State (pushState fuer bookmarkbare URLs)
    // =========================================================================

    function updateUrl() {
        var params = new URLSearchParams();
        params.set('s', new URLSearchParams(window.location.search).get('s') || '');
        params.set('post_type', 'product');

        ['filter_project', 'filter_standort', 'filter_kategorie'].forEach(function(key) {
            var values = getChecked(key + '[]');
            values.forEach(function(val) {
                params.append(key + '[]', val);
            });
        });

        if (currentPage > 1) {
            params.set('paged', currentPage);
        }

        var newUrl = window.location.pathname + '?' + params.toString();
        history.pushState({ page: currentPage }, '', newUrl);
    }

    // =========================================================================
    // Reset-Button + Mobile-Badge
    // =========================================================================

    function updateResetButton() {
        var activeCount = sidebar.querySelectorAll('input[type="checkbox"]:checked').length;
        var $reset = $sidebar.find('.search-filter-reset');

        if (activeCount > 0) {
            if (!$reset.length) {
                $sidebar.append('<a href="#" class="search-filter-reset">Filter zuruecksetzen</a>');
            }
        } else {
            $reset.remove();
        }
    }

    function updateMobileBadge() {
        var activeCount = sidebar.querySelectorAll('input[type="checkbox"]:checked').length;
        var $toggle = $layout.find('.brandner-filter-toggle');
        var $badge = $toggle.find('.filter-count');

        if (activeCount > 0) {
            if ($badge.length) {
                $badge.text(activeCount);
            } else {
                $toggle.append(' <span class="filter-count">' + activeCount + '</span>');
            }
        } else {
            $badge.remove();
        }
    }

    // =========================================================================
    // "Keine Ergebnisse" Meldung
    // =========================================================================

    function updateNoResults() {
        var noResults = document.getElementById('brandner-filter-no-results');

        if (matchingProducts.length === 0) {
            if (!noResults) {
                noResults = document.createElement('p');
                noResults.id = 'brandner-filter-no-results';
                noResults.className = 'woocommerce-info';
                noResults.textContent = 'Keine Produkte gefunden.';
                var productsList = mainEl.querySelector('ul.products');
                if (productsList) {
                    productsList.parentNode.insertBefore(noResults, productsList.nextSibling);
                }
            }
            noResults.style.display = '';
        } else {
            if (noResults) noResults.style.display = 'none';
        }
    }

    // =========================================================================
    // BrandnerRealtime Re-Initialisierung (Biet-Timer)
    // =========================================================================

    function reInitRealtime() {
        if (window.BrandnerRealtime) {
            BrandnerRealtime.destroy();
            BrandnerRealtime.init();
        }
    }

    // =========================================================================
    // Hilfsfunktionen
    // =========================================================================

    function getChecked(name) {
        var checked = sidebar.querySelectorAll('input[name="' + name + '"]:checked');
        return Array.from(checked).map(function(c) { return c.value; });
    }

    function restoreCheckboxesFromUrl() {
        var params = new URLSearchParams(window.location.search);
        sidebar.querySelectorAll('input[type="checkbox"]').forEach(function(cb) {
            var key = cb.name.replace('[]', '');
            var values = params.getAll(key + '[]');
            cb.checked = values.indexOf(cb.value) !== -1;
        });
    }

    function getPageFromUrl() {
        var params = new URLSearchParams(window.location.search);
        return parseInt(params.get('paged'), 10) || 1;
    }

    // =========================================================================
    // Event-Handler: Checkbox-Aenderung
    // =========================================================================

    sidebar.addEventListener('change', function(e) {
        if (e.target.type !== 'checkbox') return;
        applyFilter(1);
    });

    // =========================================================================
    // Event-Handler: Chip-Entfernen (X-Klick)
    // =========================================================================

    $layout.on('click', '.brandner-active-filters .remove', function(e) {
        e.preventDefault();
        var $chip = $(this).closest('.filter-chip');
        var param = $chip.data('param');
        var value = String($chip.data('value'));

        // Entsprechende Checkbox deaktivieren
        var checkboxName = param + '[]';
        $sidebar.find('input[name="' + checkboxName + '"][value="' + value + '"]').prop('checked', false);

        applyFilter(1);
    });

    // =========================================================================
    // Event-Handler: "Alle Filter entfernen"
    // =========================================================================

    $layout.on('click', '.clear-all-filters', function(e) {
        e.preventDefault();
        $sidebar.find('input[type="checkbox"]:checked').prop('checked', false);
        applyFilter(1);
    });

    // =========================================================================
    // Event-Handler: "Filter zuruecksetzen" (Sidebar-Button)
    // =========================================================================

    $sidebar.on('click', '.search-filter-reset', function(e) {
        e.preventDefault();
        $sidebar.find('input[type="checkbox"]:checked').prop('checked', false);
        applyFilter(1);
    });

    // =========================================================================
    // Event-Handler: Pagination-Klicks
    // =========================================================================

    $main.on('click', '.woocommerce-pagination a.page-numbers', function(e) {
        e.preventDefault();
        var page = parseInt(this.dataset.page, 10);
        if (!page || page === currentPage) return;

        showPage(page);
        updateUrl();

        // Smooth nach oben scrollen
        $('html, body').animate({ scrollTop: $main.offset().top - 100 }, 200);

        reInitRealtime();
    });

    // =========================================================================
    // Popstate (Browser Zurueck/Vorwaerts)
    // =========================================================================

    window.addEventListener('popstate', function(e) {
        if (e.state) {
            isPopstate = true;
            restoreCheckboxesFromUrl();
            var page = getPageFromUrl();
            applyFilter(page);
            isPopstate = false;
        } else {
            // Kein State: Checkboxen aus URL wiederherstellen
            isPopstate = true;
            restoreCheckboxesFromUrl();
            var page = getPageFromUrl();
            applyFilter(page);
            isPopstate = false;
        }
    });

    // =========================================================================
    // "Mehr anzeigen" Toggle
    // =========================================================================

    $sidebar.on('click', '.search-filter-show-more', function() {
        var section = this.closest('.search-filter-section');
        if (section) {
            section.classList.add('expanded');
        }
    });

    // =========================================================================
    // Mobile-Toggle
    // =========================================================================

    var toggleBtn = document.querySelector('.brandner-filter-toggle');
    var closeBtn = sidebar.querySelector('.search-filter-close');

    if (toggleBtn) {
        toggleBtn.addEventListener('click', function() {
            var isOpen = sidebar.classList.toggle('is-open');
            toggleBtn.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
        });
    }

    if (closeBtn) {
        closeBtn.addEventListener('click', function() {
            sidebar.classList.remove('is-open');
            if (toggleBtn) {
                toggleBtn.setAttribute('aria-expanded', 'false');
            }
        });
    }

    // =========================================================================
    // Initialisierung: Filter sofort anwenden (Checkboxen von PHP vorgehakt)
    // =========================================================================

    var initialPage = getPageFromUrl();
    applyFilter(initialPage);

    // Initialen State speichern fuer popstate
    history.replaceState({ page: currentPage }, '', window.location.href);

})(jQuery);
